/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const APOFPO = [{ id: 'APO', name: 'APO' }, { id: 'FPO', name: 'FPO' }];

export default APOFPO;
